import React from "react";

class ScrollToTopButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        this.setState({ visible: window.scrollY > 300 });
    };

    scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    render() {
        const { visible } = this.state;

        return (
            <button
                type="button"
                onClick={this.scrollToTop}
                className={`
                    fixed bottom-20 right-4 z-40 flex h-11 w-11 items-center justify-center
                    rounded-full bg-surface-elevated border border-surface-border
                    text-content-secondary shadow-elevated
                    transition-all duration-200
                    hover:bg-surface-hover hover:text-brand-light hover:shadow-glow-brand/20
                    sm:bottom-6
                    ${visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0 pointer-events-none"}
                `}
                aria-label="맨 위로 이동"
            >
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-5 w-5"
                >
                    <path d="M18 15l-6-6-6 6" />
                </svg>
            </button>
        );
    }
}

export default ScrollToTopButton;
